<template>
  <img
    v-if="resolvedSrc"
    :src="resolvedSrc"
    :alt="alt"
    :style="{ width: `${size}px` }"
  />
</template>
<script>
import FileUsecase from "@/usecases/file.usecase";

export default {
  components: {},
  data () {
    return {
      resolvedSrc: "",
    };
  },
  props: {
    src: {
      type: String,
      default: "",
    },
    alt: {
      type: String,
      default: "",
    },
    size: {
      type: Number,
      default: 50,
    },
  },
  created () {},
  mounted () {
    this.resolve(this.src);
  },
  watch: {
    src: function (after) {
      this.resolve(after);
    },
  },
  computed: {
    targetText: function () {
      return this.text || this.$itaijiFM.getText(this.itaiji);
    },
  },
  methods: {
    resolve (src) {
      if (!src) {
        return;
      }
      if (src.startsWith("http")) {
        this.resolvedSrc = src;
        return;
      }

      return usecase.file.fetchURL(src).then(url => {
        this.resolvedSrc = url;
      });
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
</style>
